<template>
  <div class="flex items-center mt-4 w-full">
    <div class="text-l-medium text-black-white mr-2">{{ $t('lighting.preset') }}</div>
    <div class="flex flex-1 items-center gap-2 w-full">
      <RadioGroup class="items-center" :disabled="disabled">
        <div class="flex justify-center items-center flex-wrap gap-2">
          <RadioGroupItem
            v-for="(color, index) in colorGroup"
            :key="index"
            :value="color"
            :disabled="disabled"
            :style="itemStyle(color)"
            :class="[
              'size-6',
              disabled ? 'cursor-not-allowed disabled:opacity-100' : 'cursor-pointer',
            ]"
            @click="changeRgb(color)"
          />
        </div>
      </RadioGroup>
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { RGB } from '@rapoo/device-sdk'

  import { computed } from 'vue'
  import { hexToRgb, rgbToHex } from '@/utils/color'

  import { RadioGroup, RadioGroupItem } from '@rapoo/element'

  const props = withDefaults(
    defineProps<{
      modelValue?: RGB
      isColorful?: boolean
      hasColorful?: boolean
      /** 无法修改颜色时预设色块禁用并显示 disabled 色 */
      disabled?: boolean
    }>(),
    {
      modelValue: () => ({ r: 0, g: 0, b: 0 }),
      isColorful: () => false,
      disabled: false,
    },
  )
  const emit = defineEmits(['update:modelValue', 'change'])

  const colorGroup = computed(() => {
    return [
      props.hasColorful ? 'linear' : '#FF0000',
      '#FF8A00',
      '#FFF500',
      '#00FF0A',
      '#00F0FF',
      '#4400FF',
      '#FF00D0',
    ]
  })
  const itemStyle = (color: string) => {
    if (props.disabled) {
      return {
        background: 'var(--color-neutral-dark-disabled)',
        border: 'none',
      }
    }
    return {
      background:
        color === 'linear'
          ? `linear-gradient(
                to right,
                hsl(0, 100%, 50%),
                hsl(60, 100%, 50%),
                hsl(120, 100%, 50%),
                hsl(180, 100%, 50%),
                hsl(240, 100%, 50%),
                hsl(300, 100%, 50%),
                hsl(359, 100%, 50%)
              )`
          : color,
      border: itemBorder(color),
    }
  }
  const hexColor = computed(() => {
    return rgbToHex(props.modelValue).toUpperCase()
  })
  const itemBorder = (color: string) => {
    let border = '1px solid var(--color-brand-blue1)'
    if (props.isColorful) {
      if (color === 'linear') return border
    } else if (hexColor.value === color) {
      return border
    }
    border = 'none'
    return border
  }
  const changeRgb = (hex: string) => {
    if (props.disabled) return
    if (hex === 'linear') {
      emit('update:modelValue', props.modelValue)
      emit('change', hex)
    } else {
      const nextRgb = hexToRgb(hex)
      emit('update:modelValue', nextRgb)
      emit('change', nextRgb)
    }
  }
</script>
